
import { useState } from 'react';
import BottomNav from '../../components/base/BottomNav';
import Header from '../../components/base/Header';

export default function Mentoria() {
  const [activeTab, setActiveTab] = useState<'mentores' | 'chats'>('mentores');

  const mentores = [
    {
      nome: 'João Pedro Santos',
      disciplina: 'Matemática',
      rating: 4.9,
      mentorias: 156,
      avatar: 'JP',
      color: 'from-blue-500 to-cyan-500',
      disponivel: true,
    },
    {
      nome: 'Ana Carolina Lima',
      disciplina: 'Física',
      rating: 4.8,
      mentorias: 142,
      avatar: 'AC',
      color: 'from-purple-500 to-pink-500',
      disponivel: true,
    },
    {
      nome: 'Carlos Eduardo Silva',
      disciplina: 'Química',
      rating: 4.7,
      mentorias: 128,
      avatar: 'CE',
      color: 'from-green-500 to-emerald-500',
      disponivel: false,
    },
    {
      nome: 'Beatriz Oliveira',
      disciplina: 'Programação',
      rating: 5.0,
      mentorias: 203,
      avatar: 'BO',
      color: 'from-orange-500 to-amber-500',
      disponivel: true,
    },
  ];

  const chats = [
    {
      nome: 'João Pedro Santos',
      ultimaMensagem: 'Entendi! Vou resolver esse exercício agora',
      tempo: '5 min',
      naoLidas: 2,
      avatar: 'JP',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      nome: 'Ana Carolina Lima',
      ultimaMensagem: 'Obrigada pela ajuda! 😊',
      tempo: '1 hora',
      naoLidas: 0,
      avatar: 'AC',
      color: 'from-purple-500 to-pink-500',
    },
    {
      nome: 'Beatriz Oliveira',
      ultimaMensagem: 'Quando podemos marcar a próxima sessão?',
      tempo: '2 horas',
      naoLidas: 1,
      avatar: 'BO',
      color: 'from-orange-500 to-amber-500',
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 pb-20">
      <Header title="Mentoria" />

      <div className="pt-16 px-6">
        {/* Search */}
        <div className="mt-4 relative">
          <input
            type="text"
            placeholder="Buscar mentores ou disciplinas..."
            className="w-full pl-12 pr-4 py-3 bg-white rounded-full shadow-md text-sm focus:outline-none focus:ring-2 focus:ring-amber-500"
          />
          <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
        </div>

        {/* Tabs */}
        <div className="mt-6 bg-white rounded-full p-1 shadow-md flex">
          <button
            onClick={() => setActiveTab('mentores')}
            className={`flex-1 py-2 px-1 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'mentores'
                ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white'
                : 'text-gray-600'
            }`}
          >
            Encontrar Mentores
          </button>
          <button
            onClick={() => setActiveTab('chats')}
            className={`flex-1 py-2 px-1 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'chats'
                ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white'
                : 'text-gray-600'
            }`}
          >
            Minhas Conversas
          </button>
        </div>

        {/* Content */}
        {activeTab === 'mentores' ? (
          <div className="mt-6 space-y-4">
            {mentores.map((mentor, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md p-5">
                <div className="flex items-start gap-4">
                  <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${mentor.color} rounded-2xl text-white font-bold text-lg flex-shrink-0`}>
                    {mentor.avatar}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <h3 className="font-bold text-gray-800">{mentor.nome}</h3>
                        <p className="text-sm text-gray-600">{mentor.disciplina}</p>
                      </div>
                      {mentor.disponivel && (
                        <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold">
                          Online
                        </span>
                      )}
                    </div>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-yellow-500" />
                        <span className="font-semibold">{mentor.rating}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-message-3-line text-gray-400" />
                        <span>{mentor.mentorias} mentorias</span>
                      </div>
                    </div>
                    <button className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white py-2 rounded-full font-semibold text-sm cursor-pointer whitespace-nowrap">
                      Iniciar Conversa
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-6 space-y-3">
            {chats.map((chat, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md p-4 flex items-center gap-4 cursor-pointer hover:shadow-lg transition-shadow">
                <div className={`w-14 h-14 flex items-center justify-center bg-gradient-to-br ${chat.color} rounded-full text-white font-bold flex-shrink-0`}>
                  {chat.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-bold text-gray-800 truncate">{chat.nome}</h3>
                    <span className="text-xs text-gray-500 flex-shrink-0">{chat.tempo}</span>
                  </div>
                  <p className="text-sm text-gray-600 truncate">{chat.ultimaMensagem}</p>
                </div>
                {chat.naoLidas > 0 && (
                  <div className="w-6 h-6 flex items-center justify-center bg-red-500 text-white rounded-full text-xs font-bold flex-shrink-0">
                    {chat.naoLidas}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}
